import { ApplicationLog, MFAAuditLog } from '@organization/api/requests'
import { ConditionalText, DateTimeCell, TableActions } from '@shared/components'
import { MenuProps } from 'antd'
import { ColumnProps } from 'antd/es/table'
import { TFunction } from 'i18next'

export const getApplicationsTableColumns = (
  actions: (content: ApplicationLog) => MenuProps['items'],
  t: TFunction
): ColumnProps<ApplicationLog>[] => [
  {
    title: t('common.modifier'),
    dataIndex: ['modifier', 'full_name'],
    key: 'modifier',
    sorter: true,
    render: (value) => (
      <ConditionalText condition={!!value}>{value}</ConditionalText>
    )
  },
  {
    title: t('form.placeholder.app_name'),
    dataIndex: 'application_name',
    key: 'application_name',
    sorter: true
  },
  {
    title: t('table.type'),
    dataIndex: 'type',
    key: 'type',
    sorter: true,
    render: (type) => t(`log_type.${type}`, type).toString()
  },
  {
    title: t('table.model'),
    dataIndex: 'model',
    key: 'model',
    sorter: true
  },
  {
    title: t('table.date_created'),
    dataIndex: 'timestamp',
    key: 'timestamp',
    sorter: true,
    render: (time) => <DateTimeCell date={time} />
  },

  {
    key: 'actions',
    align: 'center',
    width: 80,
    render: (_, row) => <TableActions options={actions(row)} />
  }
]

export const getMFATableColumns = (
  t: TFunction
): ColumnProps<MFAAuditLog>[] => [
  {
    title: t('table.user'),
    dataIndex: 'user_username',
    key: 'user_username'
  },
  {
    title: t('ip'),
    dataIndex: 'ip_address',
    key: 'ip_address'
  },
  {
    title: t('device_name'),
    dataIndex: 'user_agent',
    key: 'user_agent'
  },
  {
    title: t('table.channel'),
    dataIndex: 'channel',
    key: 'channel',
    render: (channel) => (
      <ConditionalText condition={!!channel}>{t(channel)}</ConditionalText>
    )
  },
  {
    title: t('table.type'),
    dataIndex: 'event_type',
    key: 'event_type',
    render: (type) => t(`log_mfa_type.${type}`, type).toString()
  },
  {
    title: t('table.reason'),
    dataIndex: 'reason',
    key: 'reason',
    render: (value) => (
      <ConditionalText condition={!!value}>{value}</ConditionalText>
    )
  },
  {
    title: t('table.date_created'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (time) => <DateTimeCell date={time} />
  }
]
